import { VIDEO_INPUT_QUALITY } from '@constants/chime';

export const getQualityOptions = [
  {
    label: VIDEO_INPUT_QUALITY['360p'],
    value: '360p',
  },
  {
    label: VIDEO_INPUT_QUALITY['540p'],
    value: '540p',
  },
  {
    label: VIDEO_INPUT_QUALITY['720p'],
    value: '720p',
  },
];
